export const masking_tape_pattern_length_id = 116;
export const masking_tape_width_bp_option_group_id = 117;
export const masking_tape_pattern_size_bp_option_group_id = 116;
export const max_pattern_length = 480;
export const mockup_pattern_cm = 20;
export const safe_margin = 0.25;
